import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropField(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/partners/producers/change_field_owner/${organization_id}/fetch_crop_field/${crop_field_id}`
    );
  },
  fetchProducers(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/change_field_owner/${organization_id}/fetch_producers`
    );
  },
  updateCropField(organization_id, crop_field_id, crop_field) {
    return RequesterV1.post(
      `organization/partners/producers/change_field_owner/${organization_id}/${crop_field_id}`,
      { crop_field: crop_field }
    );
  },
};
